// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- This menu row extends the MUI MenuItem primitive for popover selection styling.
import { Box, MenuItem } from '@mui/material';
import styled from 'styled-components';

import { CompanyAvatar } from '@/console/features/switch-company/switch-company.styled';

export const CompanyItem = styled(MenuItem)`
  && {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    background: none !important;
    padding: 0.25rem;
    align-self: stretch;
    border-radius: ${({ theme }) => theme.shape.buttonRadius.large};
    height: 2.75rem;
    box-shadow: inset 0 0 0 1px ${({ theme }) => theme.palette.stroke.primary};
    min-width: 15rem;
    transition: 0.2s ease-in-out;

    &:hover {
      box-shadow: inset 0 0 0 1px
        ${({ theme }) => theme.palette.stroke.secondary};

      .MuiCheckbox-root:not(.Mui-checked) > svg {
        color: ${({ theme }) => theme.palette.stroke.secondary};
      }
    }
  }
`;

export const CompanyWrapper = styled(Box)`
  && {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(2)};
  }
`;

export const CompanyAvatarInverted = styled(CompanyAvatar)`
  && {
    background-color: ${({ theme }) => theme.palette.primary.light};
    color: ${({ theme }) => theme.palette.text.primary};
  }
`;
